module.exports = __webpack_public_path__ + "img/cost_icon.3e116ec6.png";